export default __webpack_public_path__ + "media/images/footer-bg-53014969ecd317e014a388ed2ba16788.jpg";